import { Directive, ElementRef, HostListener, OnInit, Input, ViewChild,
  AfterViewInit, AfterViewChecked, Output, EventEmitter, Renderer2 } from '@angular/core';
import { CommonService } from '../services/common.service';

@Directive({ selector: '[viewMore]' })
export class ViewmoreDirective implements AfterViewInit {
  public intialBool = true;
  @Output() setShowMore: EventEmitter<any> = new EventEmitter();
  @Input() configOptions: ReadMoreConfig;
  height: any;
  lineHeightValue: any;
  inital = true;
  text = '';
  readMoreSet = false;
  setHeight =  true;
  constructor(public el: ElementRef, public renderer: Renderer2) {

  }
  ngAfterViewInit() {
    if (this.configOptions) {
      this.testText();
    }
  }

  OnChanges() {
    if (this.configOptions) {
      this.testText();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.configOptions) {
      this.inital = true;
      this.text = '';
      this.setHeight = true;
      this.el.nativeElement.querySelectorAll('span').forEach((e, index) => {
        e.parentNode.removeChild(e);
      });
      this.readMoreSet = false;
      // this.el.nativeElement.removeChild(this.el.nativeElement.firstChild);
      // this.el.nativeElement.removeChild(this.el.nativeElement.lastChild);
      this.testText();
    }

  }


  testText() {

    // let words = this.configOptions.text.split(' '), line = '', line1 = '', lineCount = 1, i, test, set = 0;
    let child, child1;



    // if (this.inital) {
    //   this.height = this.el.nativeElement.clientHeight;
    //   const text = this.renderer.createText(this.configOptions.showMoreText);
    //    this.renderer.appendChild(this.el.nativeElement,child);
    //   this.renderer.setStyle(this.el.nativeElement,'position', 'relative');
    //   this.renderer.setStyle(this.el.nativeElement.children[0],'position', 'absolute');
    //   this.renderer.setStyle(this.el.nativeElement.children[0],'right', '0.3125rem');
    //   this.renderer.setStyle(this.el.nativeElement.children[0],'bottom', '0');
    //   this.renderer.setStyle(this.el.nativeElement.children[0],'cursor', 'pointer');
    //   this.renderer.setStyle(this.el.nativeElement.children[0],'textTransform', 'uppercase');
    //   this.renderer.setStyle(this.el.nativeElement.children[0],'fontSize', this.configOptions.showMoreFont);
    //   this.renderer.setStyle(this.el.nativeElement.children[0],'color', this.configOptions.showMoreColor);
    //   lineHeightValue = Math.round(parseInt(getComputedStyle(this.el.nativeElement).fontSize, 10));
    //   this.inital = false;
    // }

    if (this.inital) {
      this.renderer.setStyle(this.el.nativeElement, 'word-break', 'normal');
      this.renderer.setStyle(this.el.nativeElement, 'white-space', 'nowrap');
      child1 = document.createElement('span');
      this.renderer.appendChild(this.el.nativeElement, child1);
      // if (this.configOptions.text.length > 130) {
        this.el.nativeElement.firstChild.nodeValue = ''    ;
        for (let textCount = 0; textCount < this.configOptions.text.length; textCount++) {

          this.text = this.text + this.configOptions.text.charAt(textCount);
          this.el.nativeElement.children[0].innerText = this.text;
          console.log(this.el.nativeElement.clientHeight);
          if (this.el.nativeElement.children[0].offsetWidth > ((this.el.nativeElement.clientWidth * 3) - 50)) {
            this.readMoreSet = true;
            this.text = this.text.substr(0, (textCount - 10 ));
            this.el.nativeElement.children[0].innerText = this.text + '...';
            console.log(this.el.nativeElement.offsetHeight);
            child = document.createElement('span');
            this.renderer.appendChild(this.el.nativeElement, child);
            this.el.nativeElement.children[1].innerText = this.configOptions.showMoreText;
            this.renderer.setStyle(this.el.nativeElement, 'word-break', 'break-all');
            this.renderer.setStyle(this.el.nativeElement, 'white-space', 'unset');
            this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
            this.renderer.setStyle(this.el.nativeElement, 'padding-right', '7px');
            this.renderer.setStyle(this.el.nativeElement.children[1], 'position', 'absolute');
            this.renderer.setStyle(this.el.nativeElement.children[1], 'right', '0.3125rem');
            this.renderer.setStyle(this.el.nativeElement.children[1], 'bottom', '-3px');
            this.renderer.setStyle(this.el.nativeElement.children[1], 'cursor', 'pointer');
            this.renderer.setStyle(this.el.nativeElement.children[1], 'color', this.configOptions.showMoreColor);
            this.renderer.setStyle(child, 'fontSize', this.configOptions.showMoreFont);
            this.height = this.el.nativeElement.children[0].offsetHeight + 15;
            this.renderer.setStyle(this.el.nativeElement, 'height', this.height +  'px');
            this.renderer.setStyle(this.el.nativeElement.children[1], 'textTransform', 'uppercase');
            this.setHeight = false;
            break;
          }

      }
      this.inital = false;
    }
    if (!this.readMoreSet) {
      this.renderer.setStyle(this.el.nativeElement, 'word-break', 'break-all');
      this.renderer.setStyle(this.el.nativeElement, 'white-space', 'unset');
    }
    if (this.setHeight) {
      this.renderer.setStyle(this.el.nativeElement, 'height', this.el.nativeElement.scrollHeight + 15 + 'px');
      this.renderer.setStyle(this.el.nativeElement, 'word-break', 'break-all');
    }
    if (this.el.nativeElement.children[1]) {
    this.renderer.listen(this.el.nativeElement.children[1], 'click', (event) => {
      if (this.el.nativeElement.children[1].innerText.toLowerCase() === this.configOptions.showMoreText.toLowerCase()) {
        this.el.nativeElement.children[0].innerText = this.configOptions.text;
        this.renderer.setStyle(this.el.nativeElement, 'transition', 'height 1s');
        this.renderer.setStyle(this.el.nativeElement, 'height', this.el.nativeElement.scrollHeight + 15 + 'px');
        // this.renderer.setStyle(this.el.nativeElement, 'max-height', 'unset');
        this.el.nativeElement.children[1].innerText = this.configOptions.showLessText;
      } else {

        this.renderer.setStyle(this.el.nativeElement, 'height', this.height + 'px');
        // this.renderer.setStyle(this.el.nativeElement, 'max-height', 75+'px');
        this.el.nativeElement.children[0].innerText = this.text + '...';
        this.renderer.setStyle(this.el.nativeElement, 'transition', ' height 1s');
        // this.renderer.setStyle(this.el.nativeElement, 'max-height', '75px');
        this.renderer.setStyle(this.el.nativeElement.children[1], 'bottom', '-3px');
        this.el.nativeElement.children[1].innerText = this.configOptions.showMoreText;
       // this.testText();
      }
    });
  }
      //   let textDisplayed = this.configOptions.text.substr(0, 125);
      //   this.el.nativeElement.firstChild.nodeValue = textDisplayed + '...';
      //   child1 = document.createElement('span');
      //   if (this.inital) {
      //     this.height = this.el.nativeElement.clientHeight;
      //     this.inital = false;
      //     this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
      //     this.renderer.setStyle(child1, 'position', 'absolute');
      //     this.renderer.setStyle(child1, 'fontSize', this.configOptions.showMoreFont);
      //     this.renderer.setStyle(child1, 'right', '0.3125rem');
      //     this.renderer.setStyle(child1, 'bottom', '-3px');
      //     this.renderer.setStyle(child1, 'cursor', 'pointer');
      //     this.renderer.setStyle(child1, 'textTransform', 'uppercase');
      //   }

      //   this.renderer.appendChild(this.el.nativeElement, child1);
      //   this.el.nativeElement.children[0].innerText = this.configOptions.showMoreText;

      // }
      //   if (this.el.nativeElement.scrollHeight > this.height) {
      //     child1 = document.createElement('span');
      //     this.renderer.setStyle(child1,'display', 'inline-block');
      //     lineHeightValue = Math.round(parseInt(getComputedStyle(this.el.nativeElement).fontSize, 10));
      //     this.renderer.setStyle(child1,'fontSize', lineHeightValue);
      //     this.renderer.appendChild(this.el.nativeElement,child1);
      //     for (i = 0; i < words.length; i++) {
      //       test = words[i] + " ";
      //       child1.innerHTML = child1.innerHTML + test;
      //       if (this.height < child1.offsetHeight) {
      //         line = line.substring(0,line.lastIndexOf(" "));
      //         line =line.substring(0,line.lastIndexOf(" "));
      //         this.el.nativeElement.firstChild.nodeValue = line + '...';
      //         this.renderer.removeChild(this.el.nativeElement,child1);
      //         this.renderer.setStyle(child,'display', 'block');
      //         this.el.nativeElement.children[0].innerText = this.configOptions.showMoreText;
      //         set++;
      //         this.renderer.listen(child, 'click', (event) => {
      //           if (this.el.nativeElement.children[0].innerText.toLowerCase() == this.configOptions.showMoreText.toLowerCase()) {
      //             this.el.nativeElement.firstChild.nodeValue = this.configOptions.text;
      //             this.renderer.setStyle(this.el.nativeElement, 'transition', '1s');
      //             this.renderer.setStyle(this.el.nativeElement, 'height', this.el.nativeElement.scrollHeight+'px');
      //             this.renderer.setStyle(this.el.nativeElement, 'max-height', 'unset');
      //             this.el.nativeElement.children[0].innerText= this.configOptions.showLessText;
      //           }
      //           else {
      //             this.renderer.setStyle(this.el.nativeElement, 'transition', ' 1s');
      //             this.renderer.setStyle(this.el.nativeElement, 'height', this.height + 'px');
      //             this.el.nativeElement.children[0].innerText = this.configOptions.showMoreText;
      //             this.testText();
      //           }
      //         });
      //         break;
      //       }
      //       else {
      //         line = line + test;
      //        this.renderer.setStyle(child,'display', 'none');
      //       }
      //     }
      //   }
      //   else{
      //     this.renderer.setStyle(child,'display', 'none');
      //   }
      //   if(set == 0){
      //    if(child1)
      //     this.el.nativeElement.children[0].innerHTML = '';
      //    if(child1)
      //     this.renderer.setStyle(child1,'display', 'none');
      //     this.el.nativeElement.firstChild.nodeValue = this.configOptions.text;
      //   }
      // }
    }

}

export interface ReadMoreConfig {
  text: string;
  showMoreText: string;
  showLessText: string;
  showMoreColor: string;
  showMoreFont: string;
  showMoreFontFamily: string;

}
